import { gql } from '@apollo/client';
import client from 'graphql/client';

interface ApplicationLogVars {
  applicationId: number;
}

interface ProjectLogVars {
  projectId: number;
}

export const logCvPrint = (variables: ApplicationLogVars) => {
  const mutation = gql`
    mutation logCvPrintClicked($applicationId: Int!) {
      logCvPrintClicked(applicationId: $applicationId)
    }
  `;

  return client.mutate({
    mutation,
    variables,
  });
};

export const logCvDownload = (variables: ApplicationLogVars) => {
  const mutation = gql`
    mutation logCvDownloadClicked($applicationId: Int!) {
      logCvDownloadClicked(applicationId: $applicationId)
    }
  `;

  return client.mutate({
    mutation,
    variables,
  });
};

export const logJobStatisticsView = (variables: ProjectLogVars) => {
  const mutation = gql`
    mutation logJobStatisticsClicked($projectId: Int!) {
      logJobStatisticsClicked(projectId: $projectId)
    }
  `;

  return client.mutate({
    mutation,
    variables,
  });
};
